import { styled } from 'styled-components';

import Plus from '../../../static/svgIcons/PinkPlus.svg';
import Minus from '../../../static/svgIcons/PurpleMinus.svg';
import { colors } from '../../styles/sharedStyled';

export const ClaimsAccordionContainer = styled.section<{
  $isExpanded: boolean;
}>`
  box-sizing: border-box;
  padding: 19px 20px;
  border-bottom: solid 2px ${colors.gray17};
  width: 100%;
  background-color: ${({ $isExpanded }) =>
    $isExpanded && `${colors.purpleAlpha5}`};

  &:first-child {
    border-radius: ${({ $isExpanded }) => $isExpanded && `20px 20px 0 0`};
  }

  &:last-child {
    border-radius: ${({ $isExpanded }) => $isExpanded && `0 0 20px 20px`};
    border-bottom: none;
  }
`;

export const ClaimsAccordionHeaderContainer = styled.div<{
  $isExpanded: boolean;
}>`
  color: ${({ $isExpanded }) =>
    $isExpanded ? `${colors.purple7}` : `${colors.black}`};
  cursor: pointer;

  margin-bottom: ${({ $isExpanded }) => ($isExpanded ? '25px' : '0')};
  position: relative;
  padding-bottom: ${({ $isExpanded }) => ($isExpanded ? '20px' : '0')};
  border-bottom: solid ${({ $isExpanded }) => ($isExpanded ? '2px' : '0')};
  border-bottom-color: ${colors.lilac};
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`;

export const ClaimsAccordionHeaderTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const MinusIcon = styled(Minus)`
  height: 15px;
  width: 15px;
`;

export const PlusIcon = styled(Plus)`
  height: 15px;
  width: 15px;
`;
